import React from "react";
import { IoAddCircleOutline } from "react-icons/io5";
import { useStores } from "../../../store";

function TotalCredits({ totalCredits, usedCredits, remainingCredits }) {
  const { PopupStore } = useStores();
  const showPopUP = () => {
    PopupStore.setGetMoreCredits(true);
  };
  return (
    <div className="flex flex-col tc1:h-[20%] md:flex-row items-center justify-between sm:ml-0 sm:h-[17%] bg-black text-white rounded-lg px-5 py-3">
      {/* Credit Info Section */}
      <div className="sm:flex sm:flex-wrap tc1:grid tc1:grid-cols-2 tc1:px-2 tc1:py-2 p-1 w-full md:w-[70%] h-full">
        {/* Total Credits */}
        <div className="flex  md:w-fit lg:w-fit md:mt-0 lg:mt-0 mt-4 tc1:mt-0  w-[40vw] items-center md:mx-auto lg:mx-auto md:py-4 lg:py-4 md:space-x-3 lg:space-x-3 space-x-2 ">
          <p className="md:text-sm tc1:text-xs lg:text-sm text-center">
            Total Credits
          </p>
          <p className="md:text-3xl lg:text-3xl text-lg font-bold  text-[#FF6b00] text-center">
            {totalCredits ? totalCredits : "20"}
          </p>
        </div>
        <div
          className="md:hidden lg:hidden tc1:mt-0 tc1:pr-0 tc1:px
        l-3 tc1:ml-5 tc1:mr-0  mt-4 md:mt-0 md:ml-0 lg:ml-0 ml-auto mr-3 flex justify-center md:justify-end"
        >
          <button
            onClick={() => {
              showPopUP();
            }}
            className="md:w-36 lg:w-36  md:h-8 tc1:px-2  lg:h-8 w-full tc1:mr-2 h-6 tc1:text-xs whitespace-nowrap flex items-center justify-center mr-1 text-[9px] bg-[#FF6b00]  hover:bg-orange-400 text-white md:rounded-lg lg:rounded-md rounded-md transition duration-300 -ml-4"
          >
            <IoAddCircleOutline className="mr-2 tc1:text-lg md:text-lg lg:text-lg " />
            Get Credits
          </button>
        </div>
        {/* Divider */}
        <div
          className="hidden md:block border border-gray-400"
          style={{
            borderImage:
              "repeating-linear-gradient(0deg, #9c9c9c -2px, #9c9c9c 1px, transparent 5px, transparent 10px) 1",
          }}
        ></div>
        {/* Used Credits */}
        <div className="flex  md:w-fit lg:w-fit  w-[40vw] items-center md:mx-auto lg:mx-auto md:py-4 lg:py-4 md:space-x-3 lg:space-x-3 space-x-2">
          <p className="md:text-sm tc1:text-xs lg:text-sm text-[10px]  text-center">
            Used Credits
          </p>
          <p className=" text-red-500 md:text-3xl lg:text-3xl text-lg font-bold  text-center">
            {usedCredits ? usedCredits : "0"}
          </p>
        </div>
        {/* Divider */}
        <div
          className="hidden md:block border border-gray-400"
          style={{
            borderImage:
              "repeating-linear-gradient(0deg, #9c9c9c -2px, #9c9c9c 1px, transparent 5px, transparent 10px) 1",
          }}
        ></div>
        {/* Remaining Credits */}
        <div className="flex tc1:ml-0 md:w-fit lg:w-fit  w-[40vw] items-center justify-center md:mx-auto lg:mx-auto py-4 tc1:py-0 ml-auto md:space-x-3 lg:space-x-3 space-x-2">
          <p className="md:text-sm tc1:text-xs lg:text-sm text-[10px]  text-center">
            Remaining Credits
          </p>
          <p className=" text-green-500 md:text-3xl lg:text-3xl text-lg font-bold  text-center">
            {remainingCredits ? remainingCredits : "20"}
          </p>
        </div>
      </div>
      {/* Get Credits Button */}
      <div className="mt-4 md:mt-0 md:flex lg:flex hidden justify-center md:justify-end">
        <button
          onClick={() => {
            showPopUP();
          }}
          className="w-40 h-10 flex items-center justify-center bg-[#FF6b00]  hover:bg-[#FF6b00]  text-white rounded-lg transition duration-300"
        >
          <IoAddCircleOutline className="mr-2 text-lg" />
          Get Credits
        </button>
      </div>
    </div>
  );
}

export default TotalCredits;
